module.exports = __webpack_public_path__ + "static/img/materialsInfo17.4e3d135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo17.png
// module id = cfrM
// module chunks = 2